module.exports = __webpack_public_path__ + "static/webroll01-5eaab6659bed590a1d3fa22a84f316a9.mp4";